export const toFormattedPrice = ({ number }: { number: number }) => {
  if (!number) return number;

  return new Intl.NumberFormat("es-AR", {
    notation: "standard",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number);
};
